<template>
  <div class="selected-site-router h-100">
    <selected-site-service-request
      v-if="selected.mappableType === 'Service Request'"
      :selected="selected"
    ></selected-site-service-request>
    <selected-site-no-spray
      v-else-if="selected.mappableType !== 'Site'"
      :selected="selected"
    ></selected-site-no-spray>
    <selected-site-default v-else :selected="selected"></selected-site-default>
  </div>
</template>

<script>
import SelectedSiteDefault from './site-details-components/selected-site-default';
import SelectedSiteNoSpray from './site-details-components/selected-site-no-spray';
import SelectedSiteServiceRequest from './site-details-components/selected-site-service-request';
export default {
  components: {
    SelectedSiteDefault,
    SelectedSiteNoSpray,
    SelectedSiteServiceRequest,
  },

  props: {
    selected: Object,
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

.selected-site-router {
  margin-top: -1.8rem;
  height: 100%;
}
</style>
